<template>
  <v-container>
    <v-row>
      <v-col v-for="(report, i) in reports" :key="i" md="3">
        <v-card class="card--shadow" @click="$router.push(report.link)">
          <v-card-text class="report-card">
            <v-icon size="40">mdi-file-table-box</v-icon>
            <h3>{{ report.text }}</h3>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    reports: [
      { link: "/report/form7", text: "FORM 7" },
      { link: "/report/monthly", text: "Monthly" },
      { link: "/report/volunteer/reported/", text: "Reported Volunteer" },
      {
        link: "/report/volunteer/dots/reported/",
        text: "DOTS Reported Volunteer",
      },
      {
        link: "/report/nomination-list",
        text: "Nomination List",
      },
      {
        link: "/report/pre-enroll-nomination-list",
        text: "Pre Enroll Nomination",
      },
      // { link: "/report/volunteers", text: "Volunteers" },
    ],
  }),
  methods: {
    getRoute(link) {
      this.$router.push(link);
    },
  },
};
</script>

<style scoped>
.report-card {
  text-align: center;
}
.report-card i {
  color: var(--primary-color);
}
.report-card h3 {
  margin-top: 5px;
  color: var(--primary-color);
  letter-spacing: 1px;
}
</style>